import script from "./NationalIdNumberInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./NationalIdNumberInput.vue?vue&type=script&setup=true&lang=ts"

import "@/styles/baseformfield.scss?vue&type=style&index=0&id=4b3797c1&scoped=true&lang=scss"
import "./NationalIdNumberInput.vue?vue&type=style&index=1&id=4b3797c1&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3797c1"]])

export default __exports__